import React from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'clsx';
import { Box, makeStyles, Theme } from '@material-ui/core';
import { format, isValid } from 'date-fns';
import { Order } from 'types/schema-generated-types';
import getOrderNumber from 'utilities/get-order-number';
import { ORDER_DATE_FORMAT } from '../../../utils/constants';

export type Props = {
  order: Order;
  activationDate: Date | null;
  children?: React.ReactNode;
  className?: string;
};

const ActivationAlertDetails = ({ order, activationDate, children, className }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation('Order');

  return (
    <Box display="flex" flexDirection="column" className={cx(classes.root, className)}>
      <Box>{t('orderNumber', { orderNumber: getOrderNumber(order) })}</Box>
      {isValid(activationDate) && (
        <Box>{t('activationDateDetail', { date: format(activationDate!, ORDER_DATE_FORMAT) })}</Box>
      )}
      {children}
    </Box>
  );
};

export default ActivationAlertDetails;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    gap: '2px',
    paddingTop: theme.spacing(1.5)
  }
}));
